exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\ninput[type=\"time\"]::-webkit-clear-button {\r\n    font-size: 18px;\r\n    height: 30px;\r\n    position: relative;\r\n    display: none;\r\n\r\n    \r\n  }\r\n  input[type=\"time\"]{\r\n  /*font-size:25px;*/\r\n  width: 100%;\r\n}\r\n/* For Firefox */\r\ninput[type='time'] {\r\n    -moz-appearance:textfield;\r\n}\r\n/* Webkit browsers like Safari and Chrome */\r\ninput[type=time]::-webkit-inner-spin-button,\r\ninput[type=time]::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/time/time.css
// module id = 958
// module chunks = 22